import React, {Component} from 'react';
import {Navigate, useParams, useLocation} from 'react-router';
import {userChartGetByDashboardID} from "../requests/UserChart";
import {Typography} from "antd";
import {userGetByEmail} from "../requests/User";
import {generateURL} from "../requests/LookerURLRoute";
import {Auth} from "@aws-amplify/auth";

const {Title} = Typography;

// Higher Order Component to provide router params to class component
function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let params = useParams();
        let location = useLocation();
        return (
            <Component
                {...props}
                params={params}
                location={location}
            />
        );
    }
    return ComponentWithRouterProp;
}


class EmbedDashboard extends Component {

    url = new URL(window.location.href);

    constructor(props) {
        super(props);
        this.state = {
            currentUserName: null,
            dashboardID: this.props.params.id,
            search: this.url.search,
            item: null
        };
    }


    componentDidMount() {
        Auth.currentSession().then((res) => {
            this.setState({currentUserName: res.getAccessToken().payload.username});
        }).then(() => {
            userChartGetByDashboardID({
                    userId: this.state.currentUserName,
                    dashboardID: this.props.params.id
                },
                (response) => {
                    userGetByEmail(this.props.auth, (r2) => {
                        generateURL(response, r2, (url) => {
                            this.setState({item: response, url: url});
                        }, (error) => {
                            console.error('Error generating URL:', error);
                        });
                    });
                });
        });

    }


    render() {
        const {item, url} = this.state;
        const a = item !== null ? (<Navigate to={{
            pathname: '/dashboard/' + item._id,
            state: {
                url: url,
                item: item
            }
        }}
        replace />) : (<div style={{background: '#fff', padding: 20, minHeight: '100%', textAlign: "center"}}>
                <Title level={4}>You don't have permission to view the embedded dashboard. Please contact
                    support.</Title>
            </div>
        );

        return (
            <React.Fragment>
                {a}
            </React.Fragment>

        );
    }
}

export default withRouter(EmbedDashboard);
